import "./novoui-vuejs80.js";
/* empty css               */
import "vue";
import "./novoui-vuejs89.js";
/* empty css               */
import "./novoui-vuejs4.js";
import "./novoui-vuejs5.js";
import "./novoui-vuejs6.js";
import "./novoui-vuejs7.js";
import "./novoui-vuejs8.js";
import "./novoui-vuejs11.js";
import "./novoui-vuejs12.js";
import "./novoui-vuejs48.js";
import "./novoui-vuejs14.js";
import "./novoui-vuejs15.js";
import "./novoui-vuejs16.js";
import "./novoui-vuejs17.js";
import "./novoui-vuejs18.js";
import "./novoui-vuejs20.js";
import "./novoui-vuejs21.js";
import "./novoui-vuejs30.js";
import "./novoui-vuejs24.js";
import "./novoui-vuejs25.js";
import "./novoui-vuejs26.js";
import "./novoui-vuejs27.js";
import "./novoui-vuejs29.js";
import "./novoui-vuejs31.js";
import "./novoui-vuejs32.js";
import "./novoui-vuejs33.js";
import "./novoui-vuejs34.js";
import "./novoui-vuejs35.js";
import "./novoui-vuejs36.js";
import "./novoui-vuejs37.js";
import "./novoui-vuejs38.js";
import "./novoui-vuejs42.js";
/* empty css                */
import "./novoui-vuejs45.js";
import "./novoui-vuejs47.js";
import { EChipSizes as e, EChipVariants as i, EChipEmphasis as r, EChipShapes as s } from "./novoui-vuejs77.js";
const g = (t) => {
  switch (t) {
    case i.fill:
      return "chip-filter-fill";
    case i.outline:
      return "chip-filter-outline";
    default:
      return "";
  }
}, E = (t) => {
  switch (t) {
    case e.sm:
      return "chip-filter-sm";
    case e.md:
      return "chip-filter-md";
    default:
      return "";
  }
}, $ = (t) => {
  switch (t) {
    case r.strong:
      return "chip-filter-strong";
    case r.default:
      return "";
    default:
      return "";
  }
}, F = (t) => {
  switch (t) {
    case s.squared:
      return "chip-filter-squared";
    case s.rounded:
      return "";
    default:
      return "";
  }
}, ot = (t) => {
  switch (t) {
    case e.sm:
      return 12;
    case e.md:
      return 14;
    default:
      return 14;
  }
}, mt = (t) => {
  const { variant: p, size: o, emphasis: m, shape: a, disabled: n } = t, l = g(p), c = E(o), h = $(m), d = F(a), u = n ? "chip-filter-disabled" : "", C = t.selected ? "chip-filter-selected" : "", f = t.prependedEmoji || t.prependedIcon ? "chip-filter-prepended" : "";
  return `chip-filter ${l} ${c} ${h} ${d} ${u} ${C} ${f}`;
};
export {
  ot as getFilterChipPrependedIconSize,
  mt as getFilterChipStyleClasses
};
